<template>
    <TprmModal
        :additional-class-name="additionalClassName"
        size="lg"
        :allow-close="!submitting"
        :open="open"
        :title="title"
        :subtitle="subtitle"
        @close="$emit('close')"
    >
        <form class="NotificationModalShell__form" @submit.prevent="$emit('submit')">
            <slot />
        </form>

        <template #footer>
            <NewButton
                color="primary"
                :loading="submitting"
                :disabled="saveDisabled"
                @click="$emit('submit')"
            >
                Save
            </NewButton>
        </template>
    </TprmModal>
</template>

<style lang="scss">
    .NotificationModalShell {
        &__form {
            display: flex;
            flex-direction: column;
        }
    }
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    export default defineComponent({
        name: 'NotificationModalShell',
        components: {
            TprmModal,
            NewButton,
        },
        props: {
            open: {
                type: Boolean,
                default: false,
            },
            submitting: {
                type: Boolean,
                default: false,
            },
            saveDisabled: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                required: true,
            },
            subtitle: {
                type: String,
                default: '',
            },
            additionalClassName: {
                type: String,
                default: '',
            },
        },
        emits: [ 'close', 'submit' ],
    });
</script>
